interface DistanceSliderProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

// Fixed distance increments matching maptoposter recommendations:
// - 4-6km: small/dense cities (Venice, Amsterdam center)
// - 8-12km: medium cities downtown (Paris, Barcelona)
// - 15-20km: large metros full view (Tokyo, Mumbai)
export const DISTANCE_OPTIONS = [
  { value: 4000, label: '4 km', description: 'Dense city center' },
  { value: 6000, label: '6 km', description: 'Small city' },
  { value: 8000, label: '8 km', description: 'Downtown focus' },
  { value: 10000, label: '10 km', description: 'City center' },
  { value: 12000, label: '12 km', description: 'Inner city' },
  { value: 15000, label: '15 km', description: 'City proper' },
  { value: 20000, label: '20 km', description: 'Full metro' },
] as const;

export const DEFAULT_DISTANCE = 12000;

export function DistanceSlider({ value, onChange, disabled }: DistanceSliderProps) {
  const currentOption = DISTANCE_OPTIONS.find(opt => opt.value === value)
    || DISTANCE_OPTIONS.find(opt => opt.value === DEFAULT_DISTANCE)!;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-primary-2-80 block text-sm font-medium">
          Map Radius
        </label>
        <span className="text-secondary-1 text-sm font-semibold">{currentOption.label}</span>
      </div>

      <div className="grid grid-cols-7 gap-1">
        {DISTANCE_OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            disabled={disabled}
            className={`rounded-md px-2 py-2 text-xs font-medium transition-colors ${
              value === option.value
                ? 'bg-secondary-1 text-white'
                : 'bg-neutral-2-10 text-neutral-2-80 hover:bg-neutral-2-20'
            } disabled:cursor-not-allowed disabled:opacity-50`}
          >
            {option.label.replace(' km', '')}
          </button>
        ))}
      </div>

      <div className="text-neutral-2-60 flex justify-between text-xs">
        <span>More detail</span>
        <span className="text-neutral-2-40">{currentOption.description}</span>
        <span>Wider area</span>
      </div>
    </div>
  );
}
